/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { Container } from './container';
import { useNavigate } from 'react-router-dom';

export const PoliciesDetailPage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();
  return (
    <Container
      goBack={() => navigate(-1)}
      onWeatherClick={(id: string) =>
        navigate(`/my-policies/actual/weather-analytics/${id}`)
      }
    />
  );
};
